/** Idle inactivity limit before auto-logout (30 minutes). */
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

/** Warning window before idle logout (60 seconds). */
export const WARNING_DURATION_MS = 60 * 1000;

/** Maximum continuous session length from ID token iat (8 hours). */
export const MAX_SESSION_MS = 8 * 60 * 60 * 1000;

/**
 * When iat + MAX_SESSION_MS is already in the past, wait this long and
 * re-read the MSAL active account before forcing logout. Avoids tearing
 * down MFA / redirect when a stale cached iat appears briefly before a
 * fresh token is available.
 */
export const ABSOLUTE_EXPIRED_GRACE_MS = 25 * 1000;

export const SESSION_BROADCAST_CHANNEL = "ctpo-session";
export const SESSION_BROADCAST_TYPE_FORCE_LOGOUT = "force-logout";

export const SESSION_LOGOUT_REASON_IDLE = "idle";
export const SESSION_LOGOUT_REASON_ABSOLUTE = "absolute";
export const SESSION_LOGOUT_REASON_MANUAL = "manual";
export const SESSION_LOGOUT_REASON_REMOTE = "remote";

export const SESSION_ENDED_KEY = "ctpo-session-ended";

export const FORCE_INTERACTIVE_LOGIN_KEY = "ctpo-force-interactive-login";

export const RETURN_URL_KEY = "ctpo-return-url";

export const DEFAULT_AFTER_LOGIN_PATH = "/ctpo/study-plans/";
